module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-typography--text-center"
  }, [_c('router-link', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    attrs: {
      "to": "/auditoria"
    }
  }, [_vm._v("\n      Generar auditoría\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.$emit('refresh', true)
      }
    }
  }, [_vm._v("\n      Actualizar\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('h1', {
    staticClass: "mdl-typography--text-center"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dvr")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("\n      Aquí se mostrarán los reportes mas recientes que hayas realizado."), _c('br'), _vm._v("\n      Comienza un proceso de Auditoría en cualquiera de los inmuebles asignados para ti.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8310fcf6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/Auditor/Newsfeed/Empty.vue
// module id = 243
// module chunks = 0